import { createActionGroup, props } from "@ngrx/store";
import { CatalogType } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataCatalogTypesActions = createActionGroup({
    source: "Data / Catalog Types",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ catalogTypes: CatalogType[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
